import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/chat/warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-1a571545"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message" }
const _hoisted_2 = { class: "leftTips" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "warningIcon",
  alt: ""
}, null, -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "tips"
}
const _hoisted_6 = { class: "redText" }
const _hoisted_7 = { class: "rightUpdateBtn" }

import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'messageToast',
  props: {
  // 富文本内容
  text: {
    type: String,
  },
  textArr: {
    type: Array,
    default: [],
  },
  customStyle: {
    type: Object,
    default: {},
  },
},
  setup(__props) {

const route = useRoute()
// console.log(route.path, 'route')
const isWhatsappPath = ref(false)

watch(
  [route],
  () => {
    // console.log(route, 'route改变了');
    if (route.path == '/whatsapp') {
      isWhatsappPath.value = true
    } else {
      isWhatsappPath.value = false
    }
  },
  {
    immediate: true,
  }
)

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['message-toast', isWhatsappPath.value ? 'noMargin' : '']),
    style: _normalizeStyle(__props.customStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (__props.text)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "tips",
              innerHTML: __props.text
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(__props.textArr[0]) + " ", 1),
              _createElementVNode("i", _hoisted_6, _toDisplayString(__props.textArr[1]), 1),
              _createTextVNode(" " + _toDisplayString(__props.textArr[2]), 1)
            ]))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _renderSlot(_ctx.$slots, "rightContent")
      ])
    ])
  ], 6))
}
}

})